<div *ngIf="stat">

	<div class="cdn-toolbar">
		<span class="label">Distribution</span>
		<div class="seg">
			<button type="button"
				[class.active]="stat.distributionMode === 'priority'"
				(click)="setMode('priority')">Priority</button>
			<button type="button"
				[class.active]="stat.distributionMode === 'least-connection'"
				(click)="setMode('least-connection')">Balanced</button>
		</div>
	</div>

	<table class="cdn-table">
		<thead>
			<tr>
				<th>CDN</th>
				<th class="num">Viewers</th>
				<th></th>
				<th class="num">Max</th>
				<th *ngIf="stream">m3u8</th>
				<th>Status</th>
				<th>On</th>
				<th class="num" title="Priority level (0 = first). CDNs with the same tier are balanced by load.">Tier</th>
			</tr>
		</thead>
		<tbody>
			<tr *ngFor="let c of stat.cdns">
				<td class="label-cell">{{ c.label }}</td>
				<td class="num">{{ c.watchers }}</td>
				<td class="sep">of</td>
				<td class="num">
					<input class="max-input" type="number" min="0" step="1"
						[value]="c.maxWatchers"
						(change)="setMaxWatchers($event, c.id)" />
				</td>
				<td *ngIf="stream">
					<a class="m3u8-link" target="_blank"
						[href]="c.src + '/' + stream.streamKey + '/index.m3u8'">m3u8</a>
				</td>
				<td>
					<div style="display:flex; align-items:center;">
						<div class="cdnNetStatus">
							<div *ngIf="c.netStatus === 0" class="netStatus undefined"></div>
							<div *ngIf="c.netStatus === 1" class="netStatus ok"></div>
							<div *ngIf="c.netStatus === 2" class="netStatus error"></div>
						</div>
						<span *ngIf="c.autoDisabled" class="badge limit"
							title="Auto-disabled until monthly traffic limit resets">LIMIT</span>
						<span *ngIf="c.gcoreManaged && c.monthLimit" class="badge usage"
							title="Traffic this month / limit">{{ (c.monthBytes / 1073741824) | number:'1.0-1' }} / {{ (c.monthLimit / 1073741824) | number:'1.0-0' }} GB</span>
					</div>
				</td>
				<td>
					<input type="checkbox"
						(change)="setActivmentStatus($event, c.id)"
						[attr.checked]="c.activmentStatus === 1 ? 'checked' : null" />
				</td>
				<td class="num">
					<input class="tier-input" type="number" min="0" max="9" step="1"
						[value]="c.tier"
						(change)="setTier($event, c.id)" />
				</td>
			</tr>
		</tbody>
	</table>

	<div class="cdn-footer">
		<div class="total">Slots used <strong>{{ stat.allWatchers }}</strong> of <strong>{{ stat.allMaxWatchers }}</strong></div>
		<button (click)="openRefreshModal(refreshModal)" nbButton size="tiny" status="basic">Reload watch pages</button>
	</div>

</div>


<ng-template #refreshModal let-data let-ref="dialogRef">
	<div style="max-width:400px">
		<nb-card>
			<nb-card-header>
				<div style="display:flex; width:100%">
					<span>Warning</span>
					<span style="display:flex; margin-left:auto; cursor:pointer;" (click)="ref.close()">
						<nb-icon [icon]="'close-outline'" pack="eva"></nb-icon>
					</span>
				</div>
			</nb-card-header>
			<nb-card-body>
				<p>This will reload all watch pages on the platform (every stream and video) and redistribute viewers across CDNs.</p>
			</nb-card-body>
			<nb-card-footer>
				<div style="display:flex; width:100%">
					<button style="display:flex; margin-left:auto; cursor:pointer;" (click)="refreshWatchers(ref)" nbButton status="danger">Reload</button>
					<button style="display:flex; margin-left:15px; cursor:pointer;" (click)="ref.close()" nbButton status="basic">Cancel</button>
				</div>
			</nb-card-footer>
		</nb-card>
	</div>
</ng-template>
